// Job photos, stored apart from the job record.
//
// Photos used to live at jobs/{jobId}/photos. They are 57.8% of the bytes in
// the jobs node, and the ONLY place they are read is the job-detail modal -
// so every job list, every dashboard and every scheduler listener paid for
// photo metadata that was never displayed. Measured: 3,262 bytes per job, of
// which photos are ~1,885.
//
// They now live at jobPhotos/{jobId}/{type} and are fetched when a job is
// opened. Reads of /jobs get about three times cheaper and stay that way as
// the number of photos per job grows.

import { db } from './firebase.js';

export const PHOTO_TYPES = ['before', 'after'];

/**
 * Firebase collapses an array with holes into an object keyed by index, so a
 * stored list can come back either way. Always hand the UI an array.
 */
function toArray(value) {
  if (!value) return [];
  return Array.isArray(value) ? value.filter(Boolean) : Object.values(value).filter(Boolean);
}

/** Load one job's photos: { before: [...], after: [...] }. */
export async function loadJobPhotos(jobId) {
  if (!jobId) return { before: [], after: [] };
  const snap = await db.ref(`jobPhotos/${jobId}`).once('value');
  const raw = snap.val() || {};
  const photos = {};
  for (const type of PHOTO_TYPES) photos[type] = toArray(raw[type]);
  return photos;
}

/** Append a photo and return the updated list for that type. */
export async function addJobPhoto(jobId, type, photoData) {
  const ref = db.ref(`jobPhotos/${jobId}/${type}`);
  const current = toArray((await ref.once('value')).val());
  const next = [...current, photoData];
  await ref.set(next);
  return next;
}

/** Remove the photo at `index` and return the updated list. */
export async function removeJobPhoto(jobId, type, index) {
  const ref = db.ref(`jobPhotos/${jobId}/${type}`);
  const current = toArray((await ref.once('value')).val());
  const next = current.filter((_, i) => i !== index);
  await ref.set(next);
  return next;
}
